module.exports = __webpack_public_path__ + "img/玫瑰花.9746acec.png";